import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
  import router from "@/router";
  import {
    landingFormWaitlistData,
    landingFormSignUpData,
    landingFormSuccessWaitlistData,
    landingFormSuccessSignUpData,
  } from "@/constants/landingData";
  import LandingFormDetails from "@/components/landing/LandingFormDetails.vue";
  import LandingForm from "@/components/landing/LandingForm.vue";
  import LandingSuccessForm from "@/components/landing/LandingSuccessForm.vue";
  import { PlansFormEnum } from "@/enums/PlansFormEnum";
  import { useIsDesktop } from "@/features/useIsDesktop";

  const MIN_DESKTOP_WIDTH = 992;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandingFormView',
  props: {
    type: {
      type: String,
      default: PlansFormEnum.WAITLIST,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(MIN_DESKTOP_WIDTH);

  const props = __props;

  const landingFormData = computed(() => {
    return props.type === PlansFormEnum.WAITLIST
      ? landingFormWaitlistData
      : landingFormSignUpData;
  });

  const landingFormSuccessData = computed(() => {
    return props.type === PlansFormEnum.WAITLIST
      ? landingFormSuccessWaitlistData
      : landingFormSuccessSignUpData;
  });

  const formSubmitted = ref(false);

  const handleFormSubmit = () => {
    formSubmitted.value = true;
  };

  const onLogin = () => {
    router.push({ name: "SignIn" });
  };

const __returned__ = { MIN_DESKTOP_WIDTH, isDesktop, props, landingFormData, landingFormSuccessData, formSubmitted, handleFormSubmit, onLogin, computed, ref, get router() { return router }, get landingFormWaitlistData() { return landingFormWaitlistData }, get landingFormSignUpData() { return landingFormSignUpData }, get landingFormSuccessWaitlistData() { return landingFormSuccessWaitlistData }, get landingFormSuccessSignUpData() { return landingFormSuccessSignUpData }, LandingFormDetails, LandingForm, LandingSuccessForm, get PlansFormEnum() { return PlansFormEnum }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})